(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.Dashboard",
                    {
                        url: "/Dashboard",
                        component: "digitalMarketingDashboard",
                        PageTitle: "Digital Marketing Dashboard | Marketing Tracker"
                    });
        }
    ]);

    app.component("digitalMarketingDashboard",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/Dashboard/digital-marketing-dashboard-template.html",
            controller: digitalMarketingDashboardController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    digitalMarketingDashboardController.$inject = ["figToaster", "marketingTrackerContactApi", "marketingTrackerActOnApi", "marketingTrackerEmailMarketingApi", "moment", "$q", "$scope", "$state"];
    function digitalMarketingDashboardController(figToaster, marketingTrackerContactApi, marketingTrackerActOnApi, marketingTrackerEmailMarketingApi, moment, $q, $scope, $state) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    isLoading: {
                        engaged: true,
                        webLeads: true,
                        emailMarketing: false
                    }
                },
                charts: { chart1: { data: [0] }, chart2: { data: [0] }, chart3: { data: [0] } },
                currentDate: moment(),
                emailMarketing: { AverageOpenRate: 0, AverageClickRate: 0 },
                formData: null,
                pageSizes: [25, 50, 100],
                months: [
                    { Name: 'January', Id: 1 },
                    { Name: 'February', Id: 2 },
                    { Name: 'March', Id: 3 },
                    { Name: 'April', Id: 4 },
                    { Name: 'May', Id: 5 },
                    { Name: 'June', Id: 6 },
                    { Name: 'July', Id: 7 },
                    { Name: 'August', Id: 8 },
                    { Name: 'September', Id: 9 },
                    { Name: 'October', Id: 10 },
                    { Name: 'November', Id: 11 },
                    { Name: 'December', Id: 12 },
                    { Name: 'All', Id: -1 }
                ],
                monthsData: [],
                resetDate: resetDate,
                resetWebLeadsChart: resetWebLeadsChart,
                selected: [],
                topEngaged: {
                    contacts: []
                },
                years: []
            });

        $scope.$on("chart-create", function (event, instance) {
            if (instance.canvas.id === "onlineWebLeads") {
                $scope.chart = instance.chart;
            }
        });

        //$scope.goToLeads = function (elements, e) {
        //    var pos = Chart.helpers.getRelativePosition(e, $scope.chart);

        //    var intersect = elements.find(function (element) {
        //        return element.inRange(pos.x, pos.y);
        //    });
        //    if (intersect) {
        //        $ctrl.itemIndex = intersect._index;
        //        //_getContacts($ctrl.selectedSource.Id, $ctrl.itemIndex);
        //        $state.go("Home.Tools.MarketingTrackerNew.DigitalMarketing.LeadSource", { formId: $ctrl.formData.Id, grouping: $ctrl.selectedSource.Id, item: $ctrl.itemIndex }, { notify: false });
        //    }
        //};

        function _getTopEngaged() {
            $ctrl.ui.isLoading.engaged = true;
            marketingTrackerContactApi.getTopEngagedContactList(10)
                .then(function (response) {
                    $ctrl.topEngaged.contacts = response;
                })
                .catch(function () {
                    $ctrl.topEngaged.contacts = [];
                })
                .finally(function () {
                    $ctrl.ui.isLoading.engaged = false;
                });
        }

        function _getFormData(startDate, endDate) {
            $ctrl.ui.isLoading.webLeads = true;
            marketingTrackerActOnApi.getFormLogListByDateRange(startDate, endDate)
                .then(function (response) {
                    $ctrl.formData = response;

                    var startingIndex = 0;
                    $ctrl.formData.Groupings.forEach(function (group, i) {
                        group.Id = i;
                        group.Icon = "document-signed";
                        if (group.Description.includes("Source")) {
                            startingIndex = i;
                            group.Icon = "mail-multiple";
                        }
                        else if (group.Description.includes("Net")) {
                            group.Icon = "dollar-bill";
                        }
                    });

                    $ctrl.selectedSource = $ctrl.formData.Groupings[startingIndex];
                    $ctrl.resetWebLeadsChart($ctrl.selectedSource);
                })
                .finally(function () {
                    $ctrl.ui.isLoading.webLeads = false;
                });
        }

        function resetDate(timeFrame) {
            //var endDate = !!timeFrame
            //    ? moment().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id, 'date': 0 }).format()
            //    : moment().format(),
            //    startDate = !!timeFrame
            //        ? moment().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id - 3, 'date': 1 }).format()
            //        : moment().subtract(3, 'month').format();
            var endDate = !!timeFrame
                ? timeFrame.month.Id === -1
                    ? moment().set({ 'year': timeFrame.year }).endOf('year').format()
                    : moment().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id - 1 }).endOf('month').format()
                : moment().endOf('month').format(),
                startDate = !!timeFrame
                    ? timeFrame.month.Id === -1
                        ? moment().set({ 'year': timeFrame.year }).startOf('year').format()
                        : moment().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id - 1 }).startOf('month').format()
                    : moment().startOf('month').format(),
                threeMonthStartDate = !!timeFrame
                    ? timeFrame.month.Id === -1
                        ? moment().set({ 'year': timeFrame.year }).startOf('year').format()
                        : moment().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id - 3 }).startOf('month').format()
                    : moment().subtract(2, 'month').startOf('month').format();

            //TODO add Online Web Leads and Top engaged
            var promises = [];
            promises.push(_getFormData(startDate, endDate));
            promises.push(_getEmailMarketing(threeMonthStartDate, endDate));
            $q.all(promises);
        }

        function _getEmailMarketing(startDate, endDate) {
            $ctrl.ui.isLoading.emailMarketing = true;

            var message = "", toastClass = "";
            marketingTrackerEmailMarketingApi.getMetricsByTimeframe(startDate, endDate)
                .then(function (response) {
                    var allMessages = [];
                    $ctrl.emailMarketing = response;
                    _.forEach(response.Metrics, function (messageArray) {
                        return _.forEach(messageArray.Messages, function (message) {
                            return allMessages.push(message);
                        });
                    });
                    $ctrl.emailMarketing.AllMessages = allMessages;
                    _resetEmailChart($ctrl.emailMarketing.Metrics);
                })
                .catch(function (error) {
                    console.log("Error: ", error);
                    message = "There was a problem importing your messages. Please try again shortly.";
                    toastClass = "is-error";
                    return figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.ui.isLoading.emailMarketing = false;
                });
        }

        function resetWebLeadsChart(dataGroup) {
            $ctrl.selectedSource = dataGroup;
            var dataArray = _.orderBy(dataGroup.Items, ['Count'], ['desc']).slice(0, 3);
            var dataLabels = dataArray.map(function (a) { return a.Name; });
            var dataShortLabels = dataArray.map(function (a) { return _textTruncate(a.Name, 20, '...'); });
            var dataInfo = dataArray.map(function (a) { return a.Count; });
            var dataColors = ['#4D8AFE', '#FBBF08', '#F75462'];

            $ctrl.charts.chart1 = {
                options: {
                    cutoutPercentage: 75,
                    legend: {
                        display: true,
                        position: "right",
                        labels: {
                            boxWidth: 12,
                            fontColor: '#2A4560',
                            fontSize: 14,
                            generateLabels: function () {
                                return dataShortLabels.map(function (a, i) {
                                    return {
                                        text: a,
                                        fillStyle: dataColors[i],
                                        hidden: false,
                                        strokeStyle: "#FFFFFF"
                                    };
                                });
                            },
                            padding: 10
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function (obj) {
                                return dataLabels[obj.index];
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: true
                },
                shortLabels: dataShortLabels,
                labels: dataLabels,
                data: Object.values(dataInfo),
                backgroundColors: Object.values(dataColors),
                borderColors: Object.values(dataColors),
                type: 'doughnut'
            };
        }

        function _resetEmailChart(dataGroup) {
            var dataArray = _.sortBy(dataGroup, [function (a) { return moment(a.Display).format(); }]);
            var dataInfo = [
                Object.values(dataArray.map(function (a) { return a.AverageOpenRate; })),
                Object.values(dataArray.map(function (a) { return a.AverageClickRate; }))
                //,dataGroup.Metrics.map(function (a) { return a.AverageOptOutRate; })
            ];

            var dataLabels = dataArray.map(function (a) { return a.Display.split(",", 2)[0]; });

            var rgbColors = ["122, 175, 212", "209,135,164"];
            $ctrl.charts.chart2 = {

                labels: dataLabels,
                series: ['Opens', 'CTR'],
                colors: [{
                    backgroundColor: "rgba(" + rgbColors[0] + ", 0.2)",
                    pointBackgroundColor: "rgba(" + rgbColors[0] + ", 1)",
                    pointHoverBackgroundColor: "rgba(" + rgbColors[0] + ", 0.8)",
                    borderColor: "rgba(" + rgbColors[0] + ", 1)",
                    pointBorderColor: '#fff',
                    pointHoverBorderColor: "rgba(" + rgbColors[0] + ", 1)"
                }, "rgba(" + rgbColors[1] + ",0.5)"],
                data: dataInfo,
                //data: [Object.values(dataInfo[0].Opens), Object.values(dataInfo[0].ClickRates)],
                //onClick: function (points, evt) {
                //    console.log(points, evt);
                //},
                datasetOverride: [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }],
                options: {
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: { beginAtZero: true }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: false,
                                position: 'right',
                                ticks: { beginAtZero: true }
                            }
                        ]
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    legend: {
                        display: true,
                        labels: {
                            fontColor: '#2A4560',
                            fontSize: 12,
                            //boxWidth: 12,
                            //generateLabels: function () {
                            //    return dataShortLabels.map(function (a, i) {
                            //        return {
                            //            text: a,
                            //            fillStyle: dataColors[i],
                            //            hidden: false,
                            //            strokeStyle: "#FFFFFF"
                            //        };
                            //    });
                            //},
                            padding: 10
                        }
                    }
                }
            };
        }

        function _textTruncate(fullString, length, ending) {
            if (length === null) {
                length = 50;
            }
            if (ending === null) {
                ending = '...';
            }
            var strLength = !!fullString ? fullString.length : 0;
            if (strLength > length) {
                return fullString.substring(0, length - ending.length) + ending;
            } else {
                return fullString;
            }
        }

        $ctrl.$onInit = function () {
            var promises = [];
            for (var i = 2015; i <= $ctrl.currentDate.year(); i++) {
                $ctrl.years.push(i);
            }
            $ctrl.selected.month = _.find($ctrl.months, function (month) {
                return month.Id === $ctrl.currentDate.month() + 1;
            });
            $ctrl.selected.year = _.find($ctrl.years, function (year) {
                return year === $ctrl.currentDate.year();
            });

            //Add promise to each api call
            promises.push(_getTopEngaged());
            promises.push(_getFormData());
            promises.push(resetDate($ctrl.selected));

            $q.all(promises);

        };
    }
})(window.app, window.angular); //jshint ignore:line